
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';

interface UserSummarySectionProps {
  enrollments: Array<{
    id: string;
    course: {
      course_name: string;
    };
    progress: number;
    status: string;
    payment_status: string;
    registered_at: string;
  }>;
  user: {
    created_at: string;
  };
}

export function UserSummarySection({ enrollments, user }: UserSummarySectionProps) {
  console.log('UserSummarySection - Raw enrollments:', enrollments);
  
  // Only count enrollments that have complete data
  const validEnrollments = enrollments.filter(e => e && e.payment_status);
  console.log('UserSummarySection - Valid enrollments:', validEnrollments);
  
  // Filter only paid or refunded enrollments
  const paidEnrollments = validEnrollments.filter(e => 
    e.payment_status === 'Paid' || e.payment_status === 'Refunded'
  );
  
  const activeEnrollments = paidEnrollments.filter(e => e.status === 'In Progress');
  const completedEnrollments = paidEnrollments.filter(e => e.status === 'Completed');
  
  console.log('UserSummarySection - Paid enrollments:', paidEnrollments.length);
  console.log('UserSummarySection - Active enrollments:', activeEnrollments.length);
  console.log('UserSummarySection - Completed enrollments:', completedEnrollments.length);
  
  const summaryCards = [
    { label: 'Total Courses', value: paidEnrollments.length },
    { 
      label: 'Active Courses', 
      value: activeEnrollments.length
    },
    { 
      label: 'Completed Courses', 
      value: completedEnrollments.length
    },
    { 
      label: 'User Created', 
      value: user?.created_at ? new Date(user.created_at).toLocaleDateString() : 'Unknown'
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
      {summaryCards.map((card) => (
        <Card key={card.label}>
          <CardContent className="p-4">
            <p className="text-sm text-muted-foreground">{card.label}</p>
            <p className="text-lg font-medium mt-1">{card.value}</p>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
